import CoursePlayer from "../pages/StudentPortal/CoursePlayer/CoursePlayer";
import Leaderboard from "../pages/StudentPortal/Leaderboard/Leaderboard";
import Quiz from "../pages/StudentPortal/Quiz/Quiz";

const privateRouteStudentComponents = [
  {
    path: "/coursePlayer",
    component: <CoursePlayer />,
  },
  {
    path: "/leaderboard",
    component: <Leaderboard />,
  },
  {
    path: "/quiz",
    component: <Quiz />,
  },
];

export default privateRouteStudentComponents;
